(function ($) {
	'use strict';

	// wrap content youtube videos
	$(".content iframe").each(function() {
		var source = $(this).attr('src');
		if(source.indexOf('youtube.com') !== -1) {
			$(this).wrap('<div class="video-wrapper"></div>');
		}
	});

} (jQuery));
